<template>
  <VWidget content-class="pa-0">
    <template slot="title">
      {{ $t('title') }}
    </template>
    <template slot="content">
      <v-data-table
        v-if="hasInvitations"
        flat
        :items="usableInvitations"
        hide-default-header
        hide-default-footer
        class="elevation-0"
      >
        <template v-slot:item="{ item }">
          <invitation-line :invitation="item" />
        </template>
      </v-data-table>

      <h4 class="pa-4 text-h6 text-center" v-else>
        {{ $t('noInvitation') }}
      </h4>
    </template>
  </VWidget>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import { VWidget } from '@argon/app/components'
import { NAMESPACE as REALTIME_NAMESPACE } from '@argon/realtime/store'
import { NAMESPACE } from '../store'
import InvitationLine from './InvitationLine'

export default {
  name: 'Invitations',
  components: {
    VWidget,
    InvitationLine
  },
  computed: {
    ...mapState(NAMESPACE, ['invitations', 'activeOrg']),
    usableInvitations() {
      return this.invitations.filter((item) => item.accepted === false)
    },
    hasInvitations() {
      return this.usableInvitations.length > 0
    },
    realtimeKey() {
      return this.activeOrg
        ? this.$store.getters[`${REALTIME_NAMESPACE}/realtimeKey`]({
            category: 'organizationInvitations',
            identifier: this.activeOrg.refid
          })
        : null
    }
  },
  methods: {
    ...mapActions(REALTIME_NAMESPACE, ['addListener', 'removeListenerCategory']),
    ...mapActions(NAMESPACE, ['listInvitations']),
    fetchData() {
      return this.listInvitations()
    }
  },
  watch: {
    realtimeKey: function (v, oldV) {
      if (oldV) {
        this.fetchData()
      }
    }
  },
  created() {
    this.fetchData().then(() => {
      this.addListener({
        category: 'organizationInvitations',
        identifier: this.activeOrg.refid
      })
    })
  },
  destroyed() {
    this.removeListenerCategory('organizationInvitations')
  }
}
</script>

<i18n>
{
  "en": {
    "noInvitation": "No pending invitation",
    "title": "@:labels.pendingInvitations"
  },
  "fr": {
    "noInvitation": "Pas d'invitation en attente",
    "title": "@:labels.pendingInvitations"
  }
}
</i18n>
